import styled from 'styled-components';

export const ContentContainer = styled.div`
  width: 100%;
  justify-content: space-between;
  // height: 100%;
  // max-height: 100%
  &.mobileScroll {
    overflow-y: scroll;
  }
`;

export const MainContainer = styled.div`
  display: flex;
  flex-direction: row;
  flex: 1;
  align-items: flex-start;

  @media (max-width: 832px) {
    flex-direction: column;
  }
`;

export const SubTableContainer = styled.div`
  position: fixed;
  bottom: 0;
  left: 0;
  width: 100%;
  boxshadow: 0px -1px 4px 0px rgba(0, 0, 0, 0.25);
`;

export const SidebarContainer = styled.div`
  display: block;
  height: calc(100vh - 56px);
  max-height: calc(100vh - 56px);
  // height: auto;

  @media (max-width: 864px) {
    display: none;
  }
`;

export const DrawerContainer = styled.div`
  display: none;

  @media (max-width: 864px) {
    display: block;
  }
`;

export const SummaryButton = styled.div`
  position: fixed;
  bottom: 0;
  width: 100%;
  background-color: #3a3a4a;
  display: none;

  @media (max-width: 864px) {
    display: block;
  }
`;

export const DrawerTitleContainer = styled.div`
  display: flex;
  flex-direction: column;
  cursor: pointer !important;
`;

export const SummaryText = styled.div`
  text-align: center;
  background-color: #3a3a4a;
  color: #ffe600;
`;

export const ChevronIcon = styled.img`
  width: 16px;
  height: 16px;
  cursor: pointer;
  transform: rotate(0deg);
  transition: transform 0.3s;
  color: #ffe600;
  align-self: center;
  margin-top: 5px;

  &.expanded {
    transform: rotate(180deg);
  }
`;

export const CommitContainer = styled.div`
  display: flex;
  flex-direction: row;
  color: #fff;
  justify-content: space-between;
  padding: 0px 10px 9px 10px;
`;

export const CommitText = styled.div`
  text-align: center;
`;
